<template>
	<div>
		<v-data-table
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				class="trucksRoadTable"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.value] || filterClassesActive(item.value)},
                                {'dense': item.dense}]"
							:key="index"
							class=""
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									v-if="item.sortable"
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span
									class="headText wh_w"
									:class="{
                                'headText_sorted': getSortColor(sortBy, item.value),
                                 'center': item.value === 'optional'
                            }">
                                {{ item.text }}
                            </span>
							<filter-drop-down v-if="item.func" :item="item">
								<filter-table
										:data-filter="filter[item.value]"
										:type-filter="item.model"
										:item="item"
										:model-filter="item.value"
										:filter-update="filterUpdate"
										:labelFilter="item.label"
										:is-disabled="filterPreloader"
										:isRefresh="isRefreshDate"
										:selectedAllElements="selectedAllElements"
										:dateAllowed="{ isSameOrBefore: true }"
										:events-list="datesColor"
										@change-sort="changeSort"
										@create-refresh="createRefresh"
										@filter-created="filterCreated"
										@updateFilterListAll="onFilteredAll(item)"
								></filter-table>
							</filter-drop-down>
						</div>
					</th>
					<th></th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="item.id"
							:idx="idx"
							:checkClasses="checkClasses"
							:permissions="permissions"
							:linksPermissions="linksPermissions"
							:filterClassesActive="filterClassesActive"
							:reason="reason"
							@updateLink="onLink"
							@updateEdit="onEdit"
							@updateRemoveItem="onRemoveItem"
							@updateCommentsPopup="onCommentsPopup"
							@updateFilterList="onFilterList"
					></table-tr>
				</template>
				<tr class="tableBottom">
					<td>n: <span>{{ listItems.length }}</span></td>
					<td :key="i" v-for="i in 9"></td>
				</tr>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:isRefresh="isRefreshDate"
				:isRefreshPage="isRefreshPage"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
		<preload v-if="isPreload"></preload>
		<trucks-road-send-invoices
				v-if="isSendInvoicesForm"
				:filters="filters"
				:datesColor="datesColor"
				:dateFilter="dateFilter"
				:defaultEmails="emailsFromSend"
				@updateTrucksRoadClose="onSendInvoicesClose"
		></trucks-road-send-invoices>
		<truck-form
				v-if="flag === 'trucks'"
				:permissions="permissions"
				:id="id"
				@updateCloseDialog="onCloseDialog"
		></truck-form>
		<drivers-form
				v-if="flag === 'drivers'"
				:permissions="permissions"
				:driverId="id"
				@updateClose="onCloseDialog"
		></drivers-form>
		<customer-form
				v-if="flag === 'customers'"
				:permissions="permissions"
				:id="id"
				@updateClose="onCloseDialog"
		></customer-form>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import TableTr from "@/components/Fleet/TrucksRoad/TrucksRoadTable/TableTr/TableTr";
import SortBtn from "@/shared/SortBtn/SortBtn";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
import FilterTable from "@/shared/FilterTable/FilterTable";
import Preload from "@/shared/Preload/Preload";
// shared
import Pagination from "@/shared/Pagination/Pagination";
// constants
import { OPTIONAL_KEYS } from "@/constants/constants";
import { trucksRoadHeader } from "@/constants/defaultHeader";
// helpers
import getUniqId from "@/helper/getUniqId";
import debounce from 'lodash.debounce';
import { formatCurrency } from "@/helper";
// async components
const TruckForm = () => import("@/components/Maintenance/Trucks/TruckForm/TruckForm");
const DriversForm = () => import("@/components/Maintenance/Drivers/DriversForm/DriversForm");
const CustomerForm = () => import("@/components/Maintenance/Customer/CustomerForm/CustomerForm");
const TrucksRoadSendInvoices = () => import("@/components/Fleet/TrucksRoad/TrucksRoadSendInvoices/TrucksRoadSendInvoices");

export default {
	name: "TrucksRoadTable",
	components: {
		DriversForm,
		TruckForm,
		CustomerForm,
		TableTr,
		FilterTable,
		Pagination,
		SortBtn,
		FilterDropDown,
		Preload,
		TrucksRoadSendInvoices,
	},
	props: {
		listItems: Array,
		emailsFromSend: Array,
		filter: Object,
		datesColor: Object,
		search: String,
		isSearch: Boolean,
		isRefresh: Boolean,
		isGenerateExport: String,
		workOrdersFilterDefault: Object,
		permissions: Object,
		dateFilter: String,
		isRefreshDate: String,
		isFilterList: String,
		getTruckId: Number,
		isSendInvoices: String
	},
	computed: {
		...mapGetters([ 'reason', 'isRefreshFilter', 'linksPermissions',
		]),
		permissionsLinks() {
			return this.linksPermissions[this.idPerm[this.flag]];
		},
		headers() {
			return trucksRoadHeader;
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		getTotal() {
			const total = this.listItems.reduce((acc, item) => acc += +item.total, 0);
			return formatCurrency(total);
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
	},
	watch: {
		listItems(val) {
			this.items = val;
		},
		isSendInvoices(val, oldVal) {
			if (val !== oldVal) {
				this.isSendInvoicesForm = true;
			}
		},
		async isGenerateExport(val, oldVal) {
			if (val !== oldVal) {
				const response = await this.onTrucksRoadExport(this.filters);
				await this.getPdf(response);
			}
		},
		async isFilterList(val, oldVal) {
			if (val !== oldVal) {
				await this.onTrucksRoadFilter({ filters: this.filters });
			}
		},
		async isRefreshDate(val, oldVal) {
			if (val !== oldVal) {
				await this.refreshFilters();
			}
		},
		async isSearch(val, oldVal) {
			if (val !== oldVal) {
				this.filters.search = this.search;
				await this.onTrucksRoadFilter({ filters: this.filters });
			}
		},
		async isRefreshFilter(val, oldVal) {
			if (val !== oldVal) {
				await this.onTrucksRoadFilter({ filters: this.filters, isRefreshDate: 1 });
			}
		},
		async isRefresh(val) {
			if (val) {
				await this.refreshFilters();
			}
		}
	},
	data() {
		return {
			id: null,
			typeForm: null,
			flag: null,
			pages: [ 25, 50, 100, 200, 'All' ],
			itemsPerPage: 100,
			page: 1,
			pageCount: 0,
			filterUpdate: false,
			sortBy: "id",
			sortDesc: true,
			menu: false,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			list: this.listItems,
			checkClasses: {},
			filterPreloader: false,
			isRefreshPage: '',
			selectedAllElements: { key: '', id: '' },
			isPreload: false,
			isSendInvoicesForm: false,
			idPerm: {
				drivers: 5,
				trucks: 3,
				trailers: 4,
				customers: 6,
				employees: 7,
			},
			linksPerm: [ 3, 4, 5, 6, 7 ],
		};
	},
	methods: {
		...mapActions([
			'onTrucksRoadFilter',
			'onWorkOrdersPreloader',
			'onTrucksRoadExport',
			'setAlert',
			'onDateFilter',
			'onLinksPermissions',
		]),
		onLink({ id, flag }) {
			this.id = id;
			this.flag = flag;
		},
		onSave() {
			this.initWorkOrdersFilter(this.filters);
		},
		onCloseDialog() {
			this.id = null;
			this.flag = null;
			this.refreshFilters();
		},
		onRefreshFilters() {
			this.refreshFilters = !this.refreshFilters;
		},
		onSendInvoicesClose() {
			this.isSendInvoicesForm = false;
		},
		onFilteredAll(item) {
			this.filterCreated(item.value);
		},
		async getPdf({ status, name, url, error }) {
			if (status) {
				const fileLink = document.createElement("a");
				fileLink.href = url;
				fileLink.setAttribute("download", name);
				document.body.appendChild(fileLink);
				fileLink.click();
			} else {
				await this.setAlert({ type: "error", message: error });
			}
		},
		filterClassesActive(filterKey) {
			const { filter_check_in_empty, filter_check_out_empty } = this.filters || {};
			return (filterKey === "filter_check_in" && filter_check_in_empty)
					|| (filterKey === "filter_check_out" && filter_check_out_empty);
		},
		onEdit(id) {
			this.$emit('updateEdit', id);
		},
		onCommentsPopup(values) {
			this.$emit('updateCommentsPopup', values);
		},
		async onFilterList() {
			this.isPreload = true;
			await this.onTrucksRoadFilter({ filters: this.filters, isRefreshDate: true });
			this.isPreload = false;
		},
		onRemoveItem(id) {
			this.$emit('updateRemoveItem', id);
		},
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
		async refreshFilters() {
			await this.onWorkOrdersPreloader(true);
			this.onDateFilter(null);
			this.$emit('updateCleanSearch');
			this.sortDesc = true;
			this.sortBy = "id";
			this.items = this.listItems;
			this.page = 1;

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					const isOptional = OPTIONAL_KEYS.some(item => i.includes(item));
					this.filters[i] = isOptional ? -1 : [];
				}

				this.filters['filter_reviewed'] = 0;
				this.filters['search'] = '';
				this.filters['filter_description'] = '';
				this.filterUpdate = true;
			}

			await this.onStartFilter();
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		toggleOrder(val) {
			const { valueFilter } = trucksRoadHeader.find(item => item.value === val);
			this.sortBy = valueFilter;
			this.sortDesc = !this.sortDesc;
		},
		initWorkOrdersFilter: debounce(async function(filters) {
			await this.onTrucksRoadFilter({ filters, isRefreshDate: 1 });
			this.isRefreshPage = getUniqId();
			this.filterPreloader = false;
		}, 800),
		changeSort({ key, value, model }) {
			switch (model) {
				case 'date':
					this.onDateFilter(value);
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['from'];
					break;
				case 'number':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['type'];
					break;
				case 'note':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'options':
					this.filters[key] = Number(value);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'checkbox':
					this.filters[key] = Number(value);
					break;
				case 'list':
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				default:
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key].length;
			}

			this.filterPreloader = true;
			this.initWorkOrdersFilter(this.filters);
		},
		async onStartFilter() {
			this.filterPreloader = true;

			await this.onTrucksRoadFilter({ filters: this.filters });
			this.filterPreloader = false;
			await this.onWorkOrdersPreloader(false);
		},
		async getFilterList() {
			for (let i = 0; i < this.headers.length; i++) {
				const value = this.headers[i].value;
				this.filtersMarker[value] = true;
				this.$set(this.checkClasses, value, false);

				if (value.includes('filter')) {
					this.filters[value] = [];
				}

				if (value === 'filter_description') {
					this.filters[value] = '';
				}

				this.filtersList[value] = [];
			}
		}
	},
	created() {
		this.getFilterList();
	},
	async mounted() {
		await this.onLinksPermissions(this.linksPerm);
	}
};
</script>

<style scoped lang="scss">
@import "trucksRoadTable";
</style>

<style lang="scss">
.trucksRoadTable {
	.v-data-table__wrapper {
		max-height: calc(100vh - 322px);
	}
}
</style>
